import { Box, Button } from '@cloudscape-design/components';
import { useState } from 'react';
import './AssigneeAvatars.scss';

interface AssigneeAvatarsProps {
  assignees: string[];
  activeUser?: string;
  onManageClick: () => void;
  disabled?: boolean;
}

function AssigneeAvatars({
  assignees,
  activeUser,
  onManageClick,
  disabled = false,
}: AssigneeAvatarsProps) {
  const [failedImages, setFailedImages] = useState<Set<string>>(new Set());

  return (
    <div className="assignee-avatars" data-testid="assignee-avatars">
      {assignees.length === 0 ? (
        <Box
          color="text-status-inactive"
          fontSize="body-s"
          data-testid="no-assignees-text"
        >
          No assignees
        </Box>
      ) : (
        assignees.map((alias) => (
          <div
            key={alias}
            className={`assignee-avatars__circle${activeUser?.toLowerCase() === alias.toLowerCase() ? ' assignee-avatars__circle--active' : ''}`}
            title={alias}
            data-testid={`avatar-${alias}`}
          >
            {failedImages.has(alias) ? (
              alias.slice(0, 2).toUpperCase()
            ) : (
              <img
                src={`https://badgephotos.corp.amazon.com/?uid=${alias}`}
                alt={alias}
                onError={() => setFailedImages((prev) => new Set(prev).add(alias))}
              />
            )}
          </div>
        ))
      )}
      <Button
        data-testid="manage-assignees-button"
        variant="icon"
        iconName="edit"
        onClick={onManageClick}
        disabled={disabled}
        ariaLabel="Manage assignees"
      />
    </div>
  );
}

export default AssigneeAvatars;
